/**
 * Single source of truth for the body sent to `orders/new`, used both when an
 * order is created and when an existing order (order_id) is updated, so the
 * order date/time, address and guest count are always sent the same way.
 *
 * `hour` is the picked slot. `hour.nextDayDate` is set for slots that cross
 * midnight and wins over `day.date`. `isAsap` is decided by the caller because
 * the ASAP scheduler decides it from the order type, not from the slot.
 */
export const buildReadyTs = ({ day, hour, isAsap }) => {
  if (isAsap || !hour || hour.hour === 'ASAP') return null
  const date = hour.nextDayDate || day?.date
  return date ? date + ' ' + hour.hour : null
}

export const buildOrderPayload = ({
  customerId,
  storeId,
  serviceTypeId,
  service,
  day,
  hour,
  isAsap,
  orderId = null,
  addressId = null,
  guestCount = null,
  discountCode = null,
  isCcTaxExempt,
}) => {
  const payload = {
    customer_id: customerId,
    is_asap: isAsap,
    store_id: storeId,
    service_type_id: parseInt(serviceTypeId),
  }
  if (orderId) payload.order_id = orderId
  if (isCcTaxExempt !== undefined) payload.is_cc_tax_exempt = isCcTaxExempt
  if (service?.requires_guest_count) payload.guest_count = guestCount
  if (discountCode) payload.discount_code = discountCode
  const readyTs = buildReadyTs({ day, hour, isAsap })
  if (readyTs) payload.ready_ts = readyTs
  if (service?.requires_address && addressId) payload.address_id = addressId
  return payload
}
